<template>
    <div>
      <div class="warp padtb20" >
        <el-row class="main">
          <el-col :span="3">
            <div class="logosmall">
              <img src="/static/img/logo@2x.png" alt />
              <!-- <img src="" alt=""> -->
              
            </div>
          </el-col>
          <el-col :span="16" :offset="3">
             <el-row>
            <el-col
              :span="5"
              v-for="(item,index) in list"
              :key="index"
              class="colred"
              @click.native="gonext(item.url,item.id)"
            >
              <!-- <router-link :to="item.url+'?type='+item.id"> -->
              <span class="colred title47bHouer">{{item.name}}</span>
              <!-- </router-link> -->
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="2">
          
        </el-col>
        </el-row>
      </div> 
      <div class="bgwrap">
        <div class="entrustinp">
          <div></div>
          <div class="textcenter col000 font30">委托找房</div>
          <div class="textcenter col000 font24">海量真实房源 就在城市好房</div>
          <el-row class="bor1">
            <el-col :span="4" class="textcenter line40">委托类型:</el-col>
            <el-col :span="16"  :offset="1"><el-input type="text"  /></el-col>
          </el-row>
          <el-row class="bor1">
            <el-col :span="4" class="textcenter line40">房屋类型:</el-col>
            <el-col :span="16"  :offset="1"><el-input type="text"  /></el-col>
          </el-row>
           <el-row class="bor1">
            <el-col :span="4" class="textcenter line40">您的姓名:</el-col>
            <el-col :span="16"  :offset="1"><el-input type="text"  /></el-col>
          </el-row>
            <el-row class="bor1">
            <el-col :span="4" class="textcenter line40">联系方式:</el-col>
            <el-col :span="16"  :offset="1"><el-input type="text"  /></el-col>
          </el-row>
          <el-row class="bor1">
            <el-col :span="4" class="textcenter line40">联系地址:</el-col>
            <el-col :span="16"  :offset="1"><el-input type="text"  /></el-col>
          </el-row>
          <el-row class="bor1">
            <el-col :span="16"><el-input type="text"  /></el-col>
            <el-col :span="6" class="textcenter line40">获取验证码</el-col>
          </el-row>
          <div class="subbtn">提交</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
          list: [
        { name: "委托出租", url: "index", id: "0" },
        { name: "写字楼租赁", url: "OfficebuildList", id: "1" },
        { name: "写字楼买卖", url: "OfficeBuildingListSale", id: "2" },
        { name: "楼盘", url: "OfficeBuildingListRealEstate", id: "3" },
      ],
        };
    },
    created() {

    },
    mounted() {

    },
    methods: {
        gonext(path, id) {
      console.log('id',path, id)
      this.select = id;
      this.$router.push({ name: path, params: { type: id } });
    },
    }
};
</script>

<style  lang="scss">
.bgwrap{
  width: 100%;
  height: 77.0625rem;
  margin-top: -2.75rem;
  background: url(../../../static/img/wt.png) no-repeat;
  background-size: 100%;
  padding-top: 10%;
}
.entrustinp{
  width: 23%;
  background: #fff;
  padding:20px 25px;
  margin: auto;
}
.bor1{
  padding: 10px 3px;
  /* border-bottom: 1px solid #E6E6E6; */
  margin: 10px 0px;
  font-size: 14px;
}
.subbtn{
  width: 100%;
  height: 3rem;
  background: url(../../../static/img/btnbg.png)  no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  font-size: 1rem;
  color: #fff;
  line-height:3rem;
  margin-top: 1.25rem;
}
.warp {
  width: 100%;
  border-bottom: 0.0625rem solid #da251d;
}
.main {
  width: 75rem;
  margin: auto;
  color: #666;
  font-size: 14px;
}
.logosmall {
  width: 9.25rem;
  height: 2.5rem;
}
.logosmall img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/entrust/entrust.vue